export const mock = {
  polling: false,
  shouldPoll: false,
  inProgress: [],
};
